import React from 'react';
import Type from 'prop-types';
import { CircularProgress } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import styles from './ScreenLoader.styles';

const ScreenLoader = props => {
  const { classes } = props;

  return (
    <div className={classes.loader}>
      <CircularProgress />
    </div>
  );
};

ScreenLoader.propTypes = {
  classes: Type.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default withStyles(styles)(ScreenLoader);
